import BaseService from '../base.service'
export class AdminOrderService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/order', parameters)
  }
}